import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import '../../../../../../assets/icons/arrowDown.svg.mjs';
import { handleKeyboardActivation } from '../../../../../../contexts/MenuContext/utils.mjs';
import '../../../../../../contexts/MicrositeMenuContext/index.mjs';
import { START_HERE_ID } from '../../../../../../contexts/MicrositeMenuContext/mapping.mjs';
import { useMicrositeMenuTranslations } from '../../../../../../contexts/MicrositeMenuContext/translations.mjs';
import { Item, ItemLabel, ArrowDownIcon, Divider } from '../../HeaderContent.styles.mjs';
import { useMicrositeMenu } from '../../../../../../contexts/MicrositeMenuContext/context.mjs';
import ArrowDownIcon__default from "../../../../../../assets/arrowDown.svg";
"use strict";
const NavigationItem = ({
  item,
  motif,
  isActive,
  onMouseEnter,
  setSelectedMenu,
  onClick,
  onTouchStart,
  onTouchEnd,
  menuIsClosed
}) => {
  const {
    language
  } = useMicrositeMenu();
  const {
    formatMessage
  } = useMicrositeMenuTranslations(language);
  const labelRef = useRef(null);
  useEffect(() => {
    if (isActive) {
      labelRef.current?.focus();
    }
  }, [isActive]);
  return /* @__PURE__ */jsxs(Item, {
    onMouseEnter,
    onTouchStart,
    onTouchEnd,
    onClick,
    onKeyDown: handleKeyboardActivation(e => {
      e.preventDefault();
      return isActive ? setSelectedMenu?.(null) : setSelectedMenu(item);
    }),
    children: [/* @__PURE__ */jsxs(ItemLabel, {
      ref: labelRef,
      tabIndex: 0,
      role: "button",
      $active: item?.active,
      $isHovered: isActive && !item?.active,
      $motif: motif,
      $isStartItem: item?.id === START_HERE_ID,
      $menuIsClosed: menuIsClosed,
      children: [formatMessage(item.label), item.variant === "dropdown" && /* @__PURE__ */jsx(ArrowDownIcon, {
        src: ArrowDownIcon__default,
        height: 4.5,
        width: 9,
        $isOpen: isActive
      })]
    }), item?.id === START_HERE_ID && /* @__PURE__ */jsx(Divider, {})]
  });
};
export { NavigationItem };
//# sourceMappingURL=NavigationItem.mjs.map
